import Model from "braindamage/model";
import DodoableSchema from 'generated/schemas/dodoable';

class Dodoable extends Model {
  static schema = DodoableSchema;
  static modelName = 'Dodoable';

  // Fill-in your attribute overrides
  static attributesDefinitions() {
    return {};
  }
}

export default Dodoable.define();
